// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates,
  DashboardUrun,
  DashboardLink,
  DashboardKategori,
  DashboardTıklanma,
} from "../components/_dashboard/app";

// ----------------------------------------------------------------------

export default function DashboardApp() {
  return (
    <Page title="Solar Paket | Anasayfa">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Solar Paket , Istatistikler</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <DashboardUrun />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DashboardLink />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DashboardKategori />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DashboardTıklanma />
          </Grid>



          <Grid item xs={12} md={12} lg={12}>
            <AppConversionRates />
          </Grid>


        </Grid>
      </Container>
    </Page>
  );
}
